import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { useAppServices } from "hook/services";

export default function DeleteAITokenPlanModal({ open, onClose, plan, onDeleted }) {
  const AppService = useAppServices();
  const [confirmText, setConfirmText] = useState("");
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    if (!open) {
      setConfirmText("");
      setDeleting(false);
    }
  }, [open]);

  if (!open || !plan) return null;

  const close = () => {
    if (deleting) return;
    onClose();
  };

  const handleDelete = async () => {
    if (confirmText.trim().toLowerCase() !== "confirm") return;
    setDeleting(true);
    const { response } = await AppService.aiTokenPlans.delete({
      query: `_id=${plan._id}`,
      toaster: true,
    });
    setDeleting(false);
    if (response?.success) {
      onDeleted && onDeleted(plan);
      onClose();
    }
  };

  const isConfirmValid = confirmText.trim().toLowerCase() === "confirm";

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.4)",
        zIndex: 1300,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      onClick={close}
    >
      <div
        style={{
          width: 460,
          maxWidth: "92vw",
          background: "#fff",
          borderRadius: 10,
          padding: 24,
          boxShadow: "0 10px 40px rgba(0,0,0,0.15)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start" }}>
          <b style={{ fontSize: 18 }}>Delete AI Task  Plan</b>
          <CloseIcon style={{ cursor: "pointer", color: "#757575" }} onClick={close} />
        </div>

        <p style={{ fontSize: 14, color: "#1E1E1E", marginTop: 14 }}>
          Once deleted your plan can not be restored. Please type{" "}
          <b>Confirm</b> to delete this plan.
        </p>

        <input
          type="text"
          value={confirmText}
          onChange={(e) => setConfirmText(e.target.value)}
          placeholder="Type Confirm"
          style={{
            width: "100%",
            marginTop: 12,
            padding: "10px 12px",
            border: "1px solid #1E1E1E",
            borderRadius: 6,
            fontSize: 14,
            outline: "none",
          }}
        />

        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 22 }}>
          <button
            onClick={close}
            disabled={deleting}
            style={{
              padding: "8px 20px",
              border: "1px solid #D9D9D9",
              background: "#fff",
              borderRadius: 6,
              fontSize: 14,
              cursor: deleting ? "not-allowed" : "pointer",
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleDelete}
            disabled={!isConfirmValid || deleting}
            style={{
              padding: "8px 22px",
              border: "none",
              background: "#F87171",
              color: "#fff",
              borderRadius: 6,
              fontSize: 14,
              fontWeight: 600,
              cursor: !isConfirmValid || deleting ? "not-allowed" : "pointer",
              opacity: !isConfirmValid || deleting ? 0.6 : 1,
            }}
          >
            {deleting ? "Deleting..." : "Delete"}
          </button>
        </div>
      </div>
    </div>
  );
}
